import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { supabase } from '../../lib/supabase'; 
import './P1_Inicio.css'; 
import P1_Avatar from './P1_Avatar'; 

const P1_Inicio = () => {
  const [busqueda, setBusqueda] = useState('');
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [modalUsuario, setModalUsuario] = useState(false); 
  const [datosBunker, setDatosBunker] = useState([]); 
  const [cargando, setCargando] = useState(true);
  const [session, setSession] = useState(null); 
  const navigate = useNavigate();

  useEffect(() => {
    const getInitialSession = async () => {
      const { data: { session: currentSession } } = await supabase.auth.getSession();
      setSession(currentSession);
    };
    getInitialSession();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => {
      if (subscription) subscription.unsubscribe();
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setCargando(true);
        const [resMaterias, resFacultades] = await Promise.all([
          supabase.from('tab_materias').select('*'),
          supabase.from('tab_facultades').select('*')
        ]);

        if (resMaterias.error) throw resMaterias.error;
        if (resFacultades.error) throw resFacultades.error;

        // 🛡️ FILTRO DE CÓDIGO: Solo materias que empiezan con números (ej: "27 - ...")
        const combinados = resMaterias.data
          .filter(m => m.nombre && /^\d+/.test(m.nombre.trim())) // 🚀 Solo si empieza con dígitos
          .map(m => {
            const f = resFacultades.data.find(facu => facu.id === m.facultad_id);
            if (!f || !f.nombre || f.nombre.trim().length === 0) return null;

            return {
              ...m,
              nombreFacultad: f.nombre.trim()
            };
          })
          .filter(item => item !== null); 

        setDatosBunker(combinados);
      } catch (error) {
        console.error("Error en el radar:", error.message);
      } finally {
        setCargando(false);
      }
    };
    fetchData();
  }, []);

  const resultadosFiltrados = datosBunker.filter(item => {
    const query = busqueda.toLowerCase();
    return (
      item.nombre.toLowerCase().includes(query) || 
      item.nombreFacultad.toLowerCase().includes(query)
    );
  });

  // 🚀 Si una facultad no tiene materias que pasaron el filtro Regex, NO aparece acá
  const grupos = resultadosFiltrados.reduce((acc, item) => {
    if (!acc[item.nombreFacultad]) {
      acc[item.nombreFacultad] = [];
    }
    acc[item.nombreFacultad].push(item);
    return acc;
  }, {});

  return (
    <div className="p1-layout">
      <Helmet>
        <title>SATXRN | Inicio - El Búnker del CBC</title>
      </Helmet>

      <header className="top-bar">
        <div className="search-container">
          <span className="prompt" onClick={() => menuAbierto && setMenuAbierto(false)} style={{ cursor: 'pointer' }}>
            {menuAbierto ? '<' : '>'}
          </span>
          <input 
            type="text" 
            className="search-input" 
            placeholder={cargando ? "ESCANEANDO..." : "BUSCAR MATERIA O FACULTAD..."} 
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            onFocus={() => setMenuAbierto(true)} 
          />
        </div>

        <div 
          className="user-icon" 
          onClick={() => !session ? navigate('/login') : setModalUsuario(true)} 
          style={{ cursor: 'pointer' }}
        >
          {session ? (
            <img 
              src={session.user.user_metadata.avatar_url || session.user.user_metadata.picture} 
              alt="u" 
              style={{ width: '28px', height: '28px', borderRadius: '50%', border: '1px solid #00ff41' }} 
              onError={(e) => { e.target.src = "https://ui-avatars.com/api/?name=U&background=00ff41&color=000"; }}
            />
          ) : (
            "[ LOGIN ]"
          )}
        </div>
      </header>

      <main className={menuAbierto ? "main-content-list" : "main-content"}>
        {menuAbierto ? (
          <div className="full-screen-menu">
            {cargando ? (
              <div className="full-screen-item">[ ACCEDIENDO... ]</div>
            ) : Object.keys(grupos).length > 0 ? (
              Object.keys(grupos).map((facuNombre) => (
                <div key={facuNombre} style={{ width: '100%' }}>
                  <div className="group-header">
                    {facuNombre.toUpperCase()}
                  </div>
                  {grupos[facuNombre].map((materia) => (
                    <div 
                      key={materia.id} 
                      className="full-screen-item"
                      onClick={() => navigate(`/materia/${materia.id}`)}
                    >
                      <span>[ {materia.nombre.toUpperCase()} ]</span>
                    </div>
                  ))}
                </div>
              ))
            ) : (
              <div className="full-screen-item empty">[ SIN RESULTADOS ]</div>
            )}
          </div>
        ) : (
          <div className="main-content">
            <h1>SATXRN</h1>
            <p>... SITIO EN CONSTRUCCION ...</p>
            <p></p>
            <p>... PARCIALES ...</p>
            <p>... EJERCICIOS RESUELTOS ...</p>
            <p>... CBC UBA ...</p>
          </div>
        )}
      </main>

      <footer className="bottom-bar" style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
        <div className="home-icon" onClick={() => { setMenuAbierto(false); setBusqueda(''); }} style={{ cursor: 'pointer' }}> 
          [ ⌂ ] 
        </div>
        <div className="home-icon" onClick={() => navigate('/info')} style={{ cursor: 'pointer' }}> 
          [ m ] 
        </div>
      </footer>

      {modalUsuario && (
        <P1_Avatar 
          session={session} 
          onClose={() => setModalUsuario(false)} 
        />
      )}
    </div>
  );
};

export default P1_Inicio;